import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

export const SecurityBadge = () => (
  <div className="flex items-center gap-1 rounded-lg border px-2 py-1">
    <Icon type="16-safe-lock" size={16} color="text-tertiary" />
    <Typography.LabelXs weight="medium" color="text-tertiary">
      {t("paywall_checkout.form.safe_and_secure")}
    </Typography.LabelXs>
  </div>
);
